import { createFileRoute } from '@tanstack/react-router';
import { ProductCreatePage } from '@/modules/products/pages/ProductCreatePage';

export const Route = createFileRoute('/dashboard/products/new')({
  component: ProductCreatePage,
});
